const CMSThemeLightGrey = '#F2F1F0';
const CMSThemeDarkGrey = '#322E31';
const CMSThemeDarkerGrey = '#1C1A1A';
const CMSThemeBlack = '#0D0D0D';
const CMSThemeBlack2 = '#1C1A1A';
const CMSThemeWhite = '#FFFFFF';


export const getContrastColor = (backgroundColor?: string) => {

    if (!backgroundColor) {
        return CMSThemeWhite; // Default to white if no background color is provided
    }

    const uppercasedBackgroundColor = backgroundColor?.toUpperCase();

    if(uppercasedBackgroundColor )

    switch (uppercasedBackgroundColor) {
        case CMSThemeLightGrey:
            return CMSThemeWhite;
        case CMSThemeBlack:
        case CMSThemeBlack2:
            return CMSThemeDarkGrey;
        case CMSThemeWhite:
            return CMSThemeLightGrey;
        case CMSThemeDarkerGrey:
            return CMSThemeDarkGrey;
        default:
            return CMSThemeWhite;
    }
};


export function isDarkColor(hex?: string): boolean {
    if (!hex || typeof hex !== 'string') {
        return false; // Invalid input
    }
    // Remove the '#' if present
    hex = hex.replace(/^#/, '');

    // Handle shorthand hex (e.g., #fff)
    if (hex.length === 3) {
        hex = hex
            ?.split('')
            ?.map((c) => c + c)
            ?.join('');
    }

    // Convert to RGB
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    // Calculate relative luminance (per ITU-R BT.709)
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

    // Return true if luminance is 128 or less (dark)
    return luminance <= 128;
}